module.exports = __webpack_public_path__ + "static/media/notification_bell.b40e13cf.mp3";